import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const tabs = [
  {
    value: "commercialRegister",
    label: "طلبات تغيير السجل التجاري",
  },
  {
    value: "supplierProfilePdf",
    label: "طلبات تغيير ملفات الموردين",
  },
];

const RequestTypeTabs = ({ activeType }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleSelect = (value) => {
    const params = new URLSearchParams(location.search);
    params.set("requestType", value);
    params.delete("page");
    navigate(`${location.pathname}?${params.toString()}`);
  };

  return (
    <div className="mb-4 flex flex-wrap items-center gap-2">
      {tabs.map((tab) => (
        <button
          key={tab.value}
          type="button"
          onClick={() => handleSelect(tab.value)}
          className={`rounded-full px-4 py-2 text-sm transition-colors ${
            activeType === tab.value
              ? "bg-blueSecondary text-white"
              : "bg-gray-100 text-gray-700 hover:bg-gray-200 dark:bg-navy-800 dark:text-white dark:hover:bg-navy-700"
          }`}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default RequestTypeTabs;
